import { mapGetters } from 'vuex'
import ActionButton from '@/components/ActionButton/index'

export default {
  name: 'Repay',
  data () {
    return {
      paymentMode: '',
      PaymentSection: false,
      Amount: '',
      paymentAmount: '',
      pageError: ''
    }
  },
  components: { ActionButton },

  computed: {
    ...mapGetters(['user', 'paymentOptions']),
  },
  mounted () {
    this.$store.dispatch('getPaymentOptions')
    this.$store.dispatch("storeMixpanelEvent", {
      eventName: "SCREEN",
      propertyName: "SCREEN_NAME",
      propertyValue: "REPAYMENT_OPTIONS"
    });
  },

  methods: {
    paymentMethod (paymentOption) {
      this.$store.dispatch("storeMixpanelEvent", {
        eventName: "REPAYMENT_OPTION_SELECTED",
        propertyName: "REPAYMENT_OPTION",
        propertyValue: paymentOption.type
      });
      if (paymentOption.type === 'CUSTOM_AMOUNT_PAYMENT') {
        this.$store.commit('setPaymentAmount', this.Amount)
        this.paymentAmount = this.Amount
        this.$store.dispatch("storeMixpanelEvent", {
          eventName: "REPAYMENT_OPTION_SELECTED",
          propertyName: "AMOUNT",
          propertyValue: this.Amount
        });
      } else {
        this.$store.commit('setPaymentAmount', paymentOption.amount)
        this.paymentAmount = paymentOption.amount
        this.$store.dispatch("storeMixpanelEvent", {
          eventName: "REPAYMENT_OPTION_SELECTED",
          propertyName: "AMOUNT",
          propertyValue: paymentOption.amount
        });
      }
      this.$store.commit('setPaymentType', paymentOption.type)
    },
    closeOutstanding () {
      this.$parent.showOutstandingSection()
    },
    showPayment () {
      if (this.paymentAmount !== '') { this.Amount = this.paymentAmount }
      if (this.Amount === '') {
        this.pageError = 'Please fill all the fields'
      } else {
        this.pageError = ''
        localStorage.setItem('txnAmount', this.Amount)
        this.$store.commit('setPaymentAmount', this.Amount)
        this.$parent.showPaymentSection()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/OutstandingDetails/component.js